import './App.css';
import { BrowserRouter as Router, Switch, Link, Route } from 'react-router-dom'

import DunbaWorld from './components/DunbaWorld';
import Countdown from './components/Countdown';
import Website from './components/website';
import DunbaHome from './components/homepage';




function App() {
  return (
    <div className="App">

      <Router>
        <Switch>
          <Route exact component={DunbaHome} path="/" />
          <Route exact component={Countdown} path="/countdown" />

        </Switch>
      </Router>

    </div>
  );
}

export default App;
